import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import st from './StudentStudyTypes.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import ToggleCheckbox from 'components/UI/ToggleCheckbox/ToggleCheckbox'
import { superAxiosRequest } from 'axiosApi'
import FormDateSelector from 'components/UI/AsideModal/Form/FormDateSelector'
import { dateFormat } from 'helpers/date'
import FormField from 'components/UI/AsideModal/Form/FormField'

const StudentStudyTypes = ({ translate }) => {
  const [types, setTypes] = useState([])

  const { modalValues, changeValue, check } = asideModalStore

  useEffect(() => {
    superAxiosRequest({ link: 'groups/payment_type', method: 'get' })
      .then((res) => {
        setTypes(res.data.result)
      })
      .catch(() => {})
  }, [])

  return (
    <div className={st.studyTypes}>
      <div className={st.toggleRadioBox}>
        {types.map((item, key) => (
          <FormField key={key}>
            <ToggleCheckbox
              label={item.label}
              labelClassName={st.toggleRadioBoxLabel}
              checked={item.value === modalValues.payment_type}
              onChange={() => changeValue(item.value, 'payment_type')}
            />
          </FormField>
        ))}
      </div>

      <div className={st.fieldSet}>
        <FormDateSelector
          placeholder={translate?.start_date}
          isRequired={true}
          label={translate?.start_date}
          onChange={(val) =>
            changeValue(dateFormat(val, 'YYYY-mm-dd'), 'start_study_at')
          }
          value={modalValues?.start_study_at || ''}
          error={check('start_study_at')}
        />
        <FormDateSelector
          placeholder={translate?.end_date}
          isRequired={true}
          label={translate?.end_date}
          onChange={(val) =>
            changeValue(dateFormat(val, 'YYYY-mm-dd'), 'finish_study_at')
          }
          value={modalValues?.finish_study_at || ''}
          error={check('finish_study_at')}
        />
      </div>
    </div>
  )
}

export default observer(StudentStudyTypes)
